<template>
  <div>
    <div class="columns">
      <div class="column is-full">
        <div class="is-pulled-right">
          <router-link to="/flyers/add">
            <b-button type="is-primary">
              チラシの追加
            </b-button>
          </router-link>
          <b-button
            class="m-l-20"
            @click="fetchFlyers"
            :loading="loading"
            rounded
          >
            <b-icon icon="autorenew"> </b-icon>
          </b-button>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-full">
        <div class="is-pulled-right">
          <div class="field">
            <b-switch v-model="showDeleted">
              「削除済」データを表示する
            </b-switch>
          </div>
        </div>

        <div v-if="loading">Loading...</div>

        <div v-if="errors.length > 0">
          {{ errors }}
        </div>

        <div v-else-if="displayData">
          <b-table
            :data="displayData"
            :bordered="true"
            :striped="true"
            :hoverable="true"
            :paginated="true"
            :per-page="20"
            :current-page.sync="currentPage"
            :pagination-simple="false"
            :pagination-position="'bottom'"
            :default-sort="'updatedAt'"
            :default-sort-direction="'desc'"
            :sort-icon="'arrow-up'"
            :sort-icon-size="'is-small'"
          >
            <template slot-scope="props">
              <b-table-column
                field="title"
                label="タイトル"
                width="350"
                searchable
                sortable
              >
                {{ props.row.title | truncate(20) }}
              </b-table-column>

              <b-table-column
                field="status"
                label="状態"
                width="100"
                class="has-text-centered"
                sortable
              >
                <b-tag
                  type="is-success"
                  v-if="
                                        props.row.status == '作成済' ||
                                            props.row.status == '変更済'
                                    "
                >
                  {{ props.row.status }}
                </b-tag>
                <b-tag
                  type="is-dark"
                  v-else-if="props.row.status == '削除済'"
                >
                  {{ props.row.status }}
                </b-tag>
                <b-tag
                  type="is-info"
                  v-else
                >
                  {{ props.row.status }}
                </b-tag>
              </b-table-column>

              <b-table-column
                field="startDate"
                label="掲載開始日"
                width="150"
                class="has-text-centered"
                sortable
                searchable
              >
                {{ props.row.startDate }}
              </b-table-column>

              <b-table-column
                field="endDate"
                label="掲載終了日"
                width="150"
                sortable
                searchable
              >
                {{ props.row.endDate }}
              </b-table-column>

              <b-table-column
                field="permalink"
                width="100"
                class="has-text-centered"
              >
                <a
                  :href="props.row.permalink"
                  v-if="props.row.status != '削除済'"
                  target="_blank"
                >リンク</a>
              </b-table-column>

              <b-table-column
                field="updatedAt"
                label="最終更新日"
                width="200"
                sortable
              >
                {{ props.row.updatedAt }}
              </b-table-column>

              <b-table-column
                field="action"
                label="操作"
                width="250"
                class="has-text-centered"
              >
                <a
                  :href="props.row.previewLink"
                  target="_blank"
                >
                  <b-button
                    type="is-info is-small"
                    outlined
                  >プレビュー</b-button>
                </a>

                <router-link
                  :to="'/flyers/edit/' + props.row.id"
                  v-if="
                                        props.row.status != '削除待機中' &&
                                            props.row.status != '削除済'
                                    "
                >
                  <b-button
                    type="is-success"
                    class="m-l-5 m-r-5 is-small"
                    outlined
                  >編集</b-button>
                </router-link>
                <b-button
                  type="is-danger is-small"
                  outlined
                  @click="deleteFlyer(props.row.id)"
                  v-if="
                                        props.row.status != '削除待機中' &&
                                            props.row.status != '削除済'
                                    "
                >削除</b-button>
                <router-link
                  :to="'/flyers/view/' + props.row.id"
                  v-if="
                                        props.row.status == '削除待機中' ||
                                            props.row.status == '削除済'
                                    "
                >
                  <b-button
                    type="is-success"
                    class="m-l-5 m-r-5 is-small"
                    outlined
                  >確認</b-button>
                </router-link>
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon
                      icon="emoticon-sad"
                      size="is-large"
                    >
                    </b-icon>
                  </p>
                  <p>Nothing here.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { components } from "aws-amplify-vue";
import { API, graphqlOperation } from "aws-amplify";
import { listFlyers } from "@/graphql/queries";
import { updateFlyer } from "@/graphql/mutations";
import { FlyerStatus } from "@/models";
import moment from "moment";

export default {
  components: {
    ...components
  },
  data: function() {
    return {
      loading: false,
      data: [],
      errors: [],
      currentPage: 1,
      showDeleted: false
    };
  },
  created: function() {
    this.fetchFlyers();
  },
  computed: {
    displayData: function() {
      if (!this.data.items) {
        return [];
      }
      let data = this.data.items;

      if (!this.showDeleted) {
        data = data.filter(item => {
          return item.status != FlyerStatus.DELETED;
        });
      }

      return data.map(item => {
        return {
          id: item.id,
          title: item.title,
          status: this.$Amplify.I18n.get(item.status),
          startDate: moment(item.startDate).format("YYYY/MM/DD"),
          endDate: moment(item.endDate).format("YYYY/MM/DD"),
          updatedAt: moment(item.updatedAt).format("YYYY/MM/DD HH:mm:ss"),
          permalink:
            process.env.VUE_APP_FLYER_BASE_URL +
            "/info/sheets/view/" +
            item.permalink,
          previewLink: process.env.VUE_APP_API_BASE_URL + "/preview/" + item.id
        };
      });
    }
  },
  methods: {
    fetchFlyers() {
      this.loading = true;
      return API.graphql(graphqlOperation(listFlyers, { limit: 100000 }))
        .then(response => {
          this.data = response.data.listFlyers;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.errors = err;
          this.loading = false;
        });
    },
    async deleteFlyer(id) {
      if (confirm("本当に削除してよろしいですか？")) {
        await API.graphql(
          graphqlOperation(updateFlyer, {
            input: {
              id: id,
              status: FlyerStatus.TO_BE_DELETED
            }
          })
        )
          .then(response => {
            this.$buefy.toast.open({
              message: "チラシを削除しました",
              type: "is-success"
            });
            return response.data;
          })
          .catch(err => {
            this.$buefy.toast.open({
              message: "チラシの削除に失敗しました",
              type: "is-danger"
            });
            console.log(err);
            this.errors = err;
          });
        this.fetchFlyers();
      }
    }
  },
  filters: {
    truncate: function(value, length, omission) {
      var l = length ? parseInt(length, 10) : 20;
      var ommision = omission ? omission.toString() : "...";

      if (value.length <= l) {
        return value;
      }

      return value.substring(0, l) + ommision;
    }
  }
};
</script>

<style lang="scss">
$spaces: (0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50); // 0から50pxまでを用意
$sides: (top, bottom, left, right); // 方向性

@each $space in $spaces {
  @each $side in $sides {
    .m-#{str-slice($side, 0, 1)}-#{$space} {
      margin-#{$side}: #{$space}px !important;
    }

    .p-#{str-slice($side, 0, 1)}-#{$space} {
      padding-#{$side}: #{$space}px !important;
    }
  }
}
</style>
